module.exports = __webpack_public_path__ + "img/ArrivedPointB.d6dba578.png";